import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import SensorsField from '../../../features/export/ExportDataBySensors/ExportDataBySensorsForm/Fields/SensorsField/SensorsField';

function VehicleSensorChartPicker({ sensors, onClickAdd, vehicleId }) {
  const [localSensors, setLocalSensors] = useState(sensors);

  const handleAdd = () => {
    onClickAdd(localSensors);
  };

  const buttonLabel = sensors.length > 0 ? 'Применить' : 'Добавить';
  const isButtonDisabled =
    localSensors.length === sensors.length &&
    localSensors.every((s) => sensors.some((os) => os.sensorTypeId === s.sensorTypeId));

  return (
    <Box sx={{ marginTop: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <SensorsField setData={setLocalSensors} data={localSensors} vehicleId={vehicleId}/>
      <Button disabled={isButtonDisabled} onClick={handleAdd} sx={{ mr: 'auto' }}>
        {buttonLabel}
      </Button>
    </Box>
  );
}

VehicleSensorChartPicker.propTypes = {
  sensors: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onClickAdd: PropTypes.func.isRequired,
  vehicleId: PropTypes.number
};

VehicleSensorChartPicker.defaultProps = {
  vehicleId: null
}

export default VehicleSensorChartPicker;
